import { render, staticRenderFns } from "./common-service-file.vue?vue&type=template&id=55f96cdd&scoped=true&"
import script from "./common-service-file.vue?vue&type=script&lang=js&"
export * from "./common-service-file.vue?vue&type=script&lang=js&"
import style0 from "./common-service-file.vue?vue&type=style&index=0&id=55f96cdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f96cdd",
  null
  
)

export default component.exports